import { formatArrivalDate } from '@/components/customercenter-ui/components/utils/formatUtils';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
interface Props {
  isInStockWithBackOrder: boolean;
  availabilityMsg: string;
  arrivalDate: string;
  backOrderedArrivalDate: string;
  availabilityClassName: string;
  isCheckout?: boolean;
  stockValue?: number;
  qty?: number;
}

interface AvailabilitySectionProps {
  value: string;
  className: string;
  arrivalDate: string;
  availabilityMsg: string;
  isCheckout?: boolean;
  stockValue?: number;
  qty?: number;
}

const AvailabilitySection: React.FC<AvailabilitySectionProps> = ({
  value,
  className,
  arrivalDate,
  availabilityMsg,
  isCheckout,
  stockValue,
  qty,
}) => (
  <>
    <section className={`${isCheckout ? 'pt-4' : 'pt-30'} text-base`}>
      <p className="inline-block font-normal">{mapLocaleToMeaningfulFormat().availability}:</p>
      {'  '}
      <strong className={`${className} font-bold leading-5`}>
        {value === 'Backordered' ? qty : value === 'Out of Stock' ? '' : stockValue} {value}
      </strong>
    </section>
    {arrivalDate && availabilityMsg !== mapLocaleToMeaningfulFormat().outOfStock && (
      <section className="text-base">
        <p className="inline-block font-normal leading-5">{mapLocaleToMeaningfulFormat().arrivesBy}</p>{' '}
        <strong className="inline-block font-bold">
          {formatArrivalDate(arrivalDate, mapLocaleToMeaningfulFormat())}
        </strong>
      </section>
    )}
  </>
);

export const AvailabilityMsgDisplay: React.FC<Props> = ({
  isInStockWithBackOrder,
  availabilityMsg,
  arrivalDate,
  backOrderedArrivalDate,
  availabilityClassName,
  isCheckout,
  stockValue,
  qty,
}) => {
  const availabilityMsgValue: any = availabilityMsg?.match(/\d+/g);
  return isInStockWithBackOrder ? (
    <>
      {availabilityMsgValue && (
        <AvailabilitySection
          value={mapLocaleToMeaningfulFormat([availabilityMsgValue?.[0]]).inStockMsg}
          className={availabilityMsgValue?.[0] > 3 ? 'text-forestGreen' : 'text-stoneberry-onlyLeft'}
          arrivalDate={arrivalDate}
          availabilityMsg={availabilityMsg}
          isCheckout={isCheckout}
        />
      )}
      <AvailabilitySection
        value={`${availabilityMsgValue?.[1] ?? ''} ${mapLocaleToMeaningfulFormat().backOrdered}`}
        className={availabilityClassName}
        arrivalDate={backOrderedArrivalDate}
        availabilityMsg={availabilityMsg}
        isCheckout={isCheckout}
        qty={qty}
      />
    </>
  ) : (
    <AvailabilitySection
      value={availabilityMsg}
      className={availabilityClassName}
      arrivalDate={arrivalDate}
      availabilityMsg={availabilityMsg}
      isCheckout={isCheckout}
      stockValue={stockValue}
      qty={qty}
    />
  );
};
